var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var toPct = function (base) {
    return "".concat(base * 100, "%");
};
// The layout is based on a 12-column grid
var cols = {
    one: 1 / 12,
    two: 2 / 12,
    three: 3 / 12,
    four: 4 / 12,
    five: 5 / 12,
    six: 6 / 12,
    seven: 7 / 12,
    eight: 8 / 12,
    nine: 9 / 12,
    ten: 10 / 12,
    eleven: 11 / 12,
    twelve: 12 / 12,
};
var sizes = __spreadArray([
    '0'
], __read(Object.values(cols)
    .sort(function (a, b) { return a - b; })
    .map(function (col) { return toPct(col); })), false);
export default sizes;
//# sourceMappingURL=sizes.js.map